<template>
  <div class="data-table">
    <SearchHeader
      ref="searchRef"
      v-if="searchColumns"
      :data="searchColumns"
      :search="search"
      @strink-change="handleStrinkChange"
      @search-change="handleSearchChange"
      @search-reset="handleSearchReset"
    />

    <div class="table-header">
      <div class="table-header-left">
        <slot name="menuLeft"></slot>
      </div>
      <div class="table-header-right">
        <slot name="menuRight"></slot>
        <!-- <el-button
          v-if="refresh"
          class="btn-refresh"
          circle
          @click="handleRefresh"
          icon="Refresh"
        >
        </el-button> -->
      </div>
    </div>
    <BasicTable
      ref="tableRef"
      v-loading="loading"
      :columns="columns"
      :data="data"
      :height="maxHeight"
      stripe
      border
      v-bind="tableProps"
    />
    <div class="table-page" v-if="page">
      <el-pagination
        ref="pageRef"
        :page-size="page.pageSize"
        :current-page="page.current"
        :page-sizes="page.pageSizes"
        :total="page.total"
        :background="true"
        layout="total,sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";

import { defineComponent, computed, ref, watch, onMounted } from "vue";
import BasicTable from "./basicTable.vue";
import SearchHeader from "./searchHeader.vue";

export default defineComponent({
  props: {
    search: {
      type: Object,
    },
    columns: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    searchColumns: {
      type: [Array, null],
      default: null,
    },
    page: {
      type: [Object, null],
      default: () => {
        return null;
      },
    },
    refresh: {
      type: Boolean,
      default: true,
    },
    calcHeight: {
      type: Number,
    },
    actualHeight: {
      type: Number,
    },
    loading: {
      type: Boolean,
    },
  },
  setup(props, context) {
    const store = useStore();

    const searchRef = ref(null);
    const tableRef = ref(null);
    const pageRef = ref(null);

    const maxHeight = ref();

    const tableProps = computed(() => {
      const tableAttrs = {};
      const eventKeys = [
        "onRefresh",
        "onCurrentChange",
        "onSizeChange",
        "onSearchReset",
        "onSearchReset",
      ];
      Object.keys(context.attrs).forEach((key) => {
        if (!eventKeys.includes(key)) {
          tableAttrs[key] = context.attrs[key];
        }
      });
      return tableAttrs;
    });

    const windowHeight = computed(() => {
      return store.state.windowHeight;
    });
    watch(windowHeight, () => {
      getMaxHeight();
    });

    onMounted(() => {
      getMaxHeight();
    });

    //utils
    const getMaxHeight = () => {
      if (!props.calcHeight) {
        maxHeight.value = undefined;
      }

      if (!tableRef.value) {
        return undefined;
      }
      const offsetTop = tableRef.value.$el.offsetTop;

      const pageHeight = props.page
        ? pageRef.value
          ? pageRef.value.$el.offsetHeight
          : 32
        : 0;

      let height = props.actualHeight
        ? props.actualHeight
        : store.state.windowHeight - offsetTop - props.calcHeight - pageHeight;

      maxHeight.value = height + "px";
    };
    const setFieldValue = (prop, value) => {
      if (searchRef.value) {
        searchRef.value.setFieldValue(prop, value);
      } else {
        console.log("DataTable Search ref Error");
      }
    };

    // events
    const handleRefresh = () => {
      context.emit("refresh");
    };
    const handleSizeChange = (val) => {
      context.emit("size-change", val);
    };
    const handleCurrentChange = (val) => {
      console.log("handleCurrentChange");
      context.emit("current-change", val);
    };
    const handleStrinkChange = (val) => {
      context.emit("strink-change", val);
      getMaxHeight();
    };
    const handleSearchChange = (val) => {
      context.emit("search-change", val);
    };
    const handleSearchReset = (val) => {
      context.emit("search-reset", val);
    };

    return {
      maxHeight,
      searchRef,
      tableRef,
      pageRef,
      tableProps,
      getMaxHeight,
      setFieldValue,
      handleRefresh,
      handleSizeChange,
      handleCurrentChange,
      handleStrinkChange,
      handleSearchChange,
      handleSearchReset,
    };
  },
  components: { BasicTable, SearchHeader },
});
</script>

<style lang="scss" scoped>
.data-table {
  width: 100%;

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px 0 5px;
    flex-wrap: wrap;
    // min-height: 40px;

    .btn-refresh {
      margin-left: 10px;
    }
  }

  .table-page {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    margin-bottom: 5px;
  }
}
</style>
